<div class="flex w-full justify-end p-6">
  <button
    type="button"
    data-testid="toggle-all-sections"
    class="text-primary-main hover:bg-standard-hover-main flex cursor-pointer items-center gap-1 rounded-md px-2 py-1 font-semibold transition-colors"
    [attr.aria-expanded]="!areAllItemsCollapsed"
    (click)="toggleAll()">
    <span>
      {{
        areAllItemsCollapsed
          ? cmsTextProvider.configuration.expandAll
          : cmsTextProvider.configuration.collapseAll
      }}
    </span>
    <span class="material-symbols-rounded text-xl!" aria-hidden="true">
      {{ areAllItemsCollapsed ? 'unfold_more' : 'unfold_less' }}
    </span>
  </button>
</div>

<ng-content />
